export default [
    {
        name: 'w1d5chemist',
        week: 1
    },
    {
        name: 'w1d5engineer',
        week: 1
    },
    {
        name: 'w1d5geologist',
        week: 1
    },
    {
        name: 'w2d5surgeon',
        week: 2
    },
    {
        name: 'w2d5medtech',
        week: 2
    },
    {
        name: 'w2d5roboter',
        week: 2
    },
    {
        name: 'w3d5mechanic',
        week: 3
    },
    {
        name: 'w3d5windenergyexpert',
        week: 3
    },
    {
        name: 'w3d5energyadviser',
        week: 3
    },
    {
        name: 'w4d5statistician',
        week: 4
    },
    {
        name: 'w4d5sportsscientist',
        week: 4
    },
    {
        name: 'w4d5psychologist',
        week: 4
    },
    {
        name: 'w4d5prothesistechnician',
        week: 4
    }
];
